/**
 * Page ID
 */
const id = {
  musicLibraryPlaylistFavorites: 'musicLibraryPlaylistFavorites',
};

export default id;
